import React from 'react';
import leftChev from '../../../../assets/images/chev-left-royal.svg';
import { joinClasses } from '../../../../utils/helpers';

/** @import { CarouselArrowProps } from '../../DashboardNewTypes' */

/**
 * Previous arrow component for the account carousel
 * @param {CarouselArrowProps} props
 */
const PrevArrow = ({ onClick, enabled = true, visible = true }) => (
    <img
        src={leftChev}
        className={joinClasses(
            'account-carousel__arrow', 
            'account-carousel__arrow--prev', 
            visible ? '' : 'account-carousel__arrow--invisible'
        )}
        onClick={enabled ? onClick : undefined}
        alt="Previous"
    />
);

export default PrevArrow;
